import { create } from 'zustand'

// Shape del usuario autenticado — espejo de AuthUserDto de abakoo-api
export interface AuthUser {
  readonly id: string
  readonly accountNumber: number
  readonly email: string
  readonly name: string
  readonly surname: string
  readonly profilePictureUrl: string | null
  readonly accountStatus: 'active'
  readonly onboardingPending: boolean
}

interface AuthState {
  accessToken: string | null
  expiresAt: string | null
  user: AuthUser | null
  // Guarda token + info de usuario tras login o verify-phone exitoso
  setAuth: (token: string, expiresAt: string, user: AuthUser) => void
  // Actualiza solo el access token (usada por el interceptor 401 tras refresh)
  setAccessToken: (token: string, expiresAt: string) => void
  // Limpia todo el estado (logout o refresh fallido)
  clear: () => void
}

// Store sin persist: intencionalmente solo en memoria.
// Al recargar la página, el token se renueva vía cookie httpOnly (silent refresh).
// Esto garantiza que XSS no pueda robar sesiones permanentes.
export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  expiresAt: null,
  user: null,
  setAuth: (accessToken, expiresAt, user) => set({ accessToken, expiresAt, user }),
  setAccessToken: (accessToken, expiresAt) => set({ accessToken, expiresAt }),
  clear: () => set({ accessToken: null, expiresAt: null, user: null }),
}))

export const useAccessToken = (): string | null => useAuthStore((s) => s.accessToken)
export const useCurrentUser = (): AuthUser | null => useAuthStore((s) => s.user)
